import { CurrencyCircleDollar } from '@phosphor-icons/react';

export default CurrencyCircleDollar;
